import { CmsObjectWithDefault } from '@components/Cms/types';

export type PinFormCmsKey =
    | 'PinFormLabel'
    | 'ForgotPinLabel'
    | 'SixDigitsError'
    | 'PinDoesntMatch'
    | 'PinSetupValidationError';

export const PinFormCmsWithDefault: CmsObjectWithDefault<PinFormCmsKey> = {
    PinFormLabel: {
        cmsId: 358285,
        defaultTranslation: '6-digit PIN',
    },
    ForgotPinLabel: {
        cmsId: 368052,
        defaultTranslation: 'Forgot PIN?',
    },
    SixDigitsError: {
        cmsId: 398434,
        defaultTranslation: 'Please enter exactly 6 digits using numbers 0-9 only.',
    },
    PinDoesntMatch: {
        cmsId: 398435,
        defaultTranslation: "The PIN you entered doesn't match the PIN you previously selected",
    },
    PinSetupValidationError: {
        cmsId: 421335,
        defaultTranslation: 'Exactly 6-digits required, with no repeating or sequential number combinations allowed',
    },
};
